import RegistrationYearFilter from './RegistrationYearFilter';

export default  RegistrationYearFilter;
